import axios from "../../../helper/axios";
import * as actionTypes from "../actionTypes";

export const selectFolderId = (folderId) => {
  return {
    type: actionTypes.SELECT_FOLDER,
    folderId,
  };
};
export const selectUserId= (userId) => {
  return {
    type: actionTypes.SET_USER_ID,
    userId,
  };
};

export const fetchFoldersStart = () => {
  return {
    type: actionTypes.FETCH_FOLDERS_START,
  };
};
export const fetchFoldersFail = (error) => {
  return {
    type: actionTypes.FETCH_FOLDERS_FAIL,
    error,
  };
};
export const fetchFoldersSuccess = (folders, count) => {
  return {
    type: actionTypes.FETCH_FOLDERS_SUCCESS,
    folders,
    count,
  };
};

export const fetchFolders = (pageN, pageS) => {
  return (dispatch) => {
    dispatch(fetchFoldersStart());
    // console.log(pageN + ' ' + pageS);
    axios
      .get(`client/folder?pageNumber=${pageN}&pageSize=${pageS}`)
      .then((res) => {
        // console.log(res);
        dispatch(fetchFoldersSuccess(res.data.folders, res.data.total));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchFoldersFail(err.response.data.message));
        } else {
          dispatch(fetchFoldersFail("Something went wrong"));
        }
      });
  };
};

// Create folder
export const createFoldersStart = () => {
  return {
    type: actionTypes.CREATE_FOLDERS_START,
  };
};
export const createFoldersFail = (error) => {
  return {
    type: actionTypes.CREATE_FOLDERS_FAIL,
    error,
  };
};
export const createFoldersSuccess = (newfolder) => {
  return {
    type: actionTypes.CREATE_FOLDERS_SUCCESS,
    newfolder,
  };
};

export const createFolders = (data , callBack) => {
  return (dispatch) => {
    dispatch(createFoldersStart());
    axios
      .post("client/folder", data)
      .then((res) => {
        // console.log(res);
        dispatch(createFoldersSuccess(res.data.folders));
        dispatch(fetchFolders());
        callBack();
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(createFoldersFail(err.response.data.message));
        } else {
          dispatch(createFoldersFail("Something went wrong"));
        }
      });
  };
};

// DELETE folder
export const deleteFoldersStart = () => {
  return {
    type: actionTypes.DELETE_FOLDERS_START,
  };
};
export const deleteFoldersFail = (error) => {
  return {
    type: actionTypes.DELETE_FOLDERS_FAIL,
    error,
  };
};
export const deleteFoldersSuccess = (folderId) => {
  return {
    type: actionTypes.DELETE_FOLDERS_SUCCESS,
    folderId,
  };
};

export const deleteFolder = (folderId) => {
  return (dispatch) => {
    dispatch(deleteFoldersStart());
    axios
      .delete(`client/folder/${folderId}`)
      .then((res) => {
        // console.log(res);
        // console.log(folderId);
        dispatch(deleteFoldersSuccess(folderId));
        dispatch(fetchFolders());
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(deleteFoldersFail(err.response.data.message));
        } else {
          dispatch(deleteFoldersFail("Something went wrong"));
        }
      });
  };
};

// Rename folder
export const renameFoldersStart = () => {
  return {
    type: actionTypes.RENAME_FOLDERS_START,
  };
};
export const renameFoldersFail = (error) => {
  return {
    type: actionTypes.RENAME_FOLDERS_FAIL,
    error,
  };
};
export const renameFoldersSuccess = (folderId, name, msg) => {
  return {
    type: actionTypes.RENAME_FOLDERS_SUCCESS,
    folderId,
    name,
    msg,
  };
};

export const renameFolder = (folderId, data , callBack) => {
  return (dispatch) => {
    dispatch(renameFoldersStart());
    axios
      .patch(`client/folder/${folderId}`, data)
      .then((res) => {
        // console.log(res);
        // console.log(folderId);
        dispatch(renameFoldersSuccess(folderId, data.folderName, res.message));
        callBack();
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(renameFoldersFail(err.response.data.message));
        } else {
          dispatch(renameFoldersFail("Something went wrong"));
        }
      });
  };
};

export const clearMsgFolder = (folderId) => {
  return {
    type: actionTypes.CLEAR_MSG_USER_FOLDER,
    folderId,
  };
};
